import React from 'react';
import II18 from '../translate/II18';
import { Block, Icon } from 'framework7-react';
import { CookieBanner } from '@palmabit/react-cookie-law';
import {
  activateAnalytics,
  disableAnalytics,
  ensurePaperflyOtel,
  gaeApp
} from '../helpers/Analytics';
import {
  DOC_TYPE_DOCUMENT,
  DOC_TYPE_ID_CHECK,
  DOC_TYPE_IMMEDIATE_CONFIRMATION,
  DOC_TYPE_INFORMATION,
  DOC_TYPE_PAYMENT,
  isRequestedDocumentsHas,
  onBrowserClose
} from '../helpers/utils';
import PropTypes from 'prop-types';
import { f7navigator, PATHS } from '../helpers/navigator';
import { getCookie } from '../../lib/utils';
import { resolveBrowserBackAction } from './browserBackTarget';

export function RequestTitle(props) {
  return (
    <p
      data-testid="homeRequestTitle"
      data-testvalue={
        props.oneDocumentMode
          ? 'requestForOneDocument'
          : 'requestTitleForManyDocuments'
      }
    >
      {II18.get(
        props.oneDocumentMode
          ? getOneDocumentRequestTitle(props.requestedDocuments[0])
          : 'home_request_for_documents',
        props.companyName
      )}
    </p>
  );
}

RequestTitle.propTypes = {
  oneDocumentMode: PropTypes.bool,
  requestedDocuments: PropTypes.array,
  companyName: PropTypes.string
};

const getOneDocumentRequestTitle = document => {
  switch (document.type) {
    case DOC_TYPE_PAYMENT:
      return 'home_request_for_payment';
    default:
      return 'home_request_for_documents';
  }
};

export function UploadTitle(props) {
  return (
    <p
      className="header"
      data-testid="homeUploadTitle"
      data-testvalue={
        props.oneDocumentMode
          ? 'uploadTitleForOneDocument'
          : 'uploadTitleForForManyDocuments'
      }
    >
      {II18.get(
        props.oneDocumentMode
          ? getOneDocumentUploadTitle(props.requestedDocuments[0])
          : 'home_will_docs'
      )}
    </p>
  );
}

UploadTitle.propTypes = {
  oneDocumentMode: PropTypes.bool,
  requestedDocuments: PropTypes.array
};

const getOneDocumentUploadTitle = document => {
  switch (document.type) {
    case DOC_TYPE_PAYMENT:
      return 'home_will_pay';
    default:
      return 'home_will_docs';
  }
};

export function MobileBlockTitle(props) {
  let title = 'home_with_mobile_scan';
  if (props.oneDocumentMode) {
    const document = props.requestedDocuments[0];
    switch (document.type) {
      case DOC_TYPE_PAYMENT:
        title = 'home_with_mobile';
      //no default
    }
  }
  return (
    <label
      style={{ fontSize: 16, marginBottom: 25 }}
      data-testid="homeMobileBlockTitle"
      data-testvalue={
        props.oneDocumentMode
          ? 'mobileBlockTitleForOneDocument'
          : 'mobileBlockTitleForManyDocuments'
      }
    >
      {II18.get(title)}
    </label>
  );
}

MobileBlockTitle.propTypes = {
  oneDocumentMode: PropTypes.bool,
  requestedDocuments: PropTypes.array
};

export function DesktopBlockTitle(props) {
  return (
    <label
      style={{ fontSize: 16, marginBottom: 15, minHeight: 45 }}
      data-testid="homeDesktoplBlockTitle"
      data-testvalue={
        props.oneDocumentMode
          ? 'desktopBlockTitleForOneDocument'
          : 'desktopBlockTitleForManyDocuments'
      }
    >
      {II18.get(
        props.oneDocumentMode
          ? getOneDocumentDesktopBlockTitle(props.requestedDocuments[0])
          : 'home_load_with'
      )}
    </label>
  );
}

DesktopBlockTitle.propTypes = {
  oneDocumentMode: PropTypes.bool,
  requestedDocuments: PropTypes.array
};

const getOneDocumentDesktopBlockTitle = document => {
  switch (document.type) {
    case DOC_TYPE_PAYMENT:
      return 'home_pay_with';
    default:
      return 'home_load_with';
  }
};

export function UploadButtonTitle(props) {
  return (
    <label
      data-testid="homeUploadButtonTitle"
      data-testvalue={
        props.oneDocumentMode
          ? 'uploadButtonTitleForOneDocument'
          : 'uploadButtonTitleForManyDocuments'
      }
    >
      {props.actionButtonLabel ||
        II18.get(
          !props.requestedDocuments
            ? II18.get('title_next')
            : props.oneDocumentMode
            ? getOneDocumentUploadButtonTitle(props.requestedDocuments[0])
            : getManyDocumentsUploadButtonTitle(props.requestedDocuments)
        )}
    </label>
  );
}

UploadButtonTitle.propTypes = {
  actionButtonLabel: PropTypes.string,
  oneDocumentMode: PropTypes.bool,
  requestedDocuments: PropTypes.array
};

const getOneDocumentUploadButtonTitle = document => {
  switch (document.type) {
    case DOC_TYPE_DOCUMENT:
    case DOC_TYPE_ID_CHECK:
      return 'home_now_load_one';
    case DOC_TYPE_PAYMENT:
      return 'home_now_pay';
    case DOC_TYPE_INFORMATION:
    case DOC_TYPE_IMMEDIATE_CONFIRMATION:
      return 'home_now_info';
    default:
      return document.smartFill ? 'title_next' : 'home_now_view_one';
  }
};

const getManyDocumentsUploadButtonTitle = documents => {
  if (
    isRequestedDocumentsHas(documents, [DOC_TYPE_DOCUMENT, DOC_TYPE_ID_CHECK])
  ) {
    return 'home_now_load';
  } else return 'home_now_view';
};

export function RequestIsClosedMessage(props) {
  return (
    <div
      data-testid="requestIsClosedMessage"
      style={{ textAlign: 'center', padding: 20 }}
    >
      <Icon
        style={{ marginTop: 10 }}
        material="highlight_off"
        size={props.iconSize}
        color="gray"
      />
      <h3 style={{ marginTop: 20 }}>
        <II18>home_request_closed</II18>
      </h3>
    </div>
  );
}

RequestIsClosedMessage.propTypes = {
  iconSize: PropTypes.number
};

export function RequestIsNotExistsMessage(props) {
  return (
    <div
      data-testid="requestIsNotExistsMessage"
      style={{ textAlign: 'center' }}
    >
      <Block>
        <Icon material="highlight_off" size={props.iconSize} color="gray" />
      </Block>
      <Block strong inset>
        {props.recipientRequestId === 'oynGd7NXehWbkHQrhfgDCLGXeMAmtaLYIPF4' ? (
          <>
            <h3>Dieser QR-Code ist leider fehlerhaft gedruckt worden.</h3>
            <h4>
              Ein neuer QR-Code wird Ihnen in den nächsten Tagen per Post
              zugestellt.
            </h4>
            <h4>Für die Unannehmlichkeiten bitten wir um Entschuldigung!</h4>
          </>
        ) : (
          <II18>home_request_notexists</II18>
        )}
      </Block>
    </div>
  );
}

RequestIsNotExistsMessage.propTypes = {
  iconSize: PropTypes.number,
  recipientRequestId: PropTypes.string
};

export function ErrorMessageBlock({ errorMessage }) {
  return (
    <Block style={{ textAlign: 'center' }}>
      <Block>
        <II18>technical_error</II18>
      </Block>
      <Block strong inset>
        <p>
          <span style={{ color: 'red' }}>{errorMessage}</span>
        </p>
      </Block>
    </Block>
  );
}

ErrorMessageBlock.propTypes = {
  errorMessage: PropTypes.string
};

export function ShowCookieBanner(props) {
  return (
    <CookieBanner
      message={II18.get('home_cookies_main')}
      acceptButtonText={II18.get('home_cookie_accept')}
      necessaryOptionText={II18.get('home_cookie_necessary')}
      statisticsOptionText={II18.get('home_cookie_statistic')}
      wholeDomain={true}
      onAccept={() => {
        activateAnalytics(props.queryRequestId);
      }}
      onAcceptPreferences={() => {}}
      onAcceptStatistics={() => {}}
      onAcceptMarketing={() => {}}
      showPreferencesOption={false}
      showMarketingOption={false}
    />
  );
}

ShowCookieBanner.propTypes = {
  queryRequestId: PropTypes.string
};

export function InjectCookieBanner() {
  const buttonWrapper = document.getElementsByClassName(
    'react-cookie-law-button-wrapper'
  )[0];

  const editButton = document.getElementById('cookieEditBtn');
  if (buttonWrapper && !editButton) {
    const button = document.createElement('button');
    // noinspection CheckTagEmptyBody
    button.innerHTML = '<span>' + II18.get('home_cookie_change') + '</span>';
    button.className = 'react-cookie-law-accept-btn';
    button.id = 'cookieEditBtn';
    // noinspection JSValidateTypes
    button.style =
      'margin-right: 10px !important; display: inline-block; background-color: rgb(0, 0, 0); padding: 3px; min-width: 80px; color: rgb(255, 255, 255); text-decoration: none; font-size: 10pt; font-weight: 400; margin-right: 5px; margin-left: 5px; text-align: center; white-space: nowrap; cursor: pointer;';

    buttonWrapper.appendChild(button);

    // 3. Add event handler
    button.addEventListener('click', function() {
      document.body.className = document.body.className.replace(
        'noCookieSettings',
        ''
      );
    });
  }
}

function logStartInfo(f7) {
  gaeApp('START', window.pwaSession);
  gaeApp('PWA_VER: ', window.pwaVersion);
  gaeApp('OS', f7.device.os);
  gaeApp('OS_VERSION', f7.device.osVersion);

  const device = f7.device.iphone
    ? 'iPhone'
    : f7.device.ipad
    ? 'iPad'
    : f7.device.android
    ? 'Android'
    : f7.device.desktop
    ? 'Desktop'
    : 'Another';

  const browser = window.isChrome
    ? 'Chrome'
    : window.isSafari
    ? 'Safari'
    : f7.device.ie
    ? 'InternetExplorer'
    : f7.device.edge
    ? 'Edge'
    : f7.device.firefox
    ? 'Firefox'
    : 'Another';

  gaeApp('DEVICE', device);
  gaeApp('BROWSER', browser);
}

export function initAppSettings(props) {
  const {
    analyticsDisabled,
    caseName,
    companyName,
    skipListMode,
    skipStartPage,
    crossDeviceMode,
    onBrowserBack,
    queryRequestId,
    f7,
    f7router,
    templateMode,
    scanEnded,
    brandingDetails
  } = props;

  if (window.appInitDone) return;
  window.appInitDone = true;

  window.analyticsDisabled = analyticsDisabled;
  if (analyticsDisabled === true || !queryRequestId) {
    disableAnalytics();
  } else {
    const statistics_consent_already =
      getCookie('rcl_statistics_consent') === 'true';
    statistics_consent_already && activateAnalytics(queryRequestId);
  }

  // OTel session is independent of cookies; ensure before boot diary lines.
  ensurePaperflyOtel(queryRequestId);
  logStartInfo(f7);

  gaeApp(
    'LOAD_REQUEST_DONE',
    JSON.stringify(
      {
        companyName,
        caseName,
        scanEnded
      },
      null,
      2
    )
  );

  document.title =
    caseName && companyName ? caseName + ' | ' + companyName : 'Paperfly';

  if (templateMode && !scanEnded) {
    if (!window.beforeuploadExists) {
      window.addEventListener('beforeunload', onBrowserClose);
      window.beforeuploadExists = true;
    }
  }

  if (brandingDetails.customHeaderBackgroundColor) {
    doCustomBranding(brandingDetails);
  }

  const router = f7router;
  const app = f7;

  /**
   * Overwrite default Back function of Browser.
   *
   * close Actions if opened
   * close PopUp if opened
   * cross-device: Scan QR, same as in-app back (never List)
   * go to Home if skipListMode and a start page exists
   * go to List in all other situations
   *
   */
  window.history.pushState(null, document.title, window.location.href);
  window.addEventListener('popstate', function() {
    window.history.pushState(null, document.title, window.location.href);

    const actions = document.getElementById('uploader_actions');
    const popup = document.querySelector('.popup.modal-in');
    const sheet = document.querySelector('.sheet-modal');
    const action = resolveBrowserBackAction({
      crossDeviceMode,
      routerUrl: router.url,
      skipListMode,
      skipStartPage,
      actionsOpen: Boolean(actions?.f7Modal?.opened),
      popupOpen: Boolean(popup?.f7Modal?.opened),
      sheetOpen: Boolean(sheet?.f7Modal?.opened),
      embedMode: Boolean(brandingDetails.embedMode)
    });

    switch (action) {
      case 'close-actions':
        app.actions.close(actions, true);
        break;
      case 'close-popup':
        app.popup.close(popup, true);
        break;
      case 'close-sheet':
        app.sheet.close(sheet, true);
        break;
      case 'embed-parent':
        window.parent.postMessage('PWA_NAVIGATE_BACK', '*');
        break;
      case 'cross-device-back':
        if (typeof onBrowserBack === 'function') {
          onBrowserBack();
        }
        break;
      case 'home':
        f7navigator.forceBackTo(PATHS.HOME);
        break;
      case 'list':
        f7navigator.forceBackToList();
        break;
      default:
        break;
    }
  });
}

function setBrowserThemeColor(color) {
  let metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (!metaThemeColor) {
    metaThemeColor = document.createElement('meta');
    metaThemeColor.setAttribute('name', 'theme-color');
    document.head.appendChild(metaThemeColor);
  }
  metaThemeColor.content = color;

  // Safari applies live theme-color updates when body background matches
  // https://roger.zone/theme-color-preview/
  if (!window.isDesktop) {
    document.body.style.backgroundColor = color;
  }
}

function doCustomBranding(branding) {
  const customBackgroundColor = branding.customHeaderBackgroundColor;
  const customTextColor = branding.customHeaderFontColor;
  const embedBackground = branding.embedBackground;

  if (customBackgroundColor) {
    setBrowserThemeColor(customBackgroundColor);
  }

  const createCustomColorRuleValue = color =>
    `color: ${color || customTextColor} !important;`;
  const createCustomBgColorRuleValue = color =>
    `background: ${color || customBackgroundColor} !important;`;

  const createCustomColorRule = (alias, color) =>
    `.customBranding ${alias} {${createCustomColorRuleValue(color)}}`;
  const createCustomBgColorRule = (alias, color) =>
    `.customBranding ${alias} {${createCustomBgColorRuleValue(color)}}`;

  const applyCustomBackgroundAndColorRule = alias =>
    `.customBranding ${alias} {
    ${customBackgroundColor ? createCustomBgColorRuleValue() : ''}
    ${customTextColor ? createCustomColorRuleValue() : ''}
    }`;

  const customStyle = document.createElement('style');
  document.body.appendChild(customStyle);
  const sheet = customStyle.sheet;
  sheet.insertRule(
    applyCustomBackgroundAndColorRule('#homePageStartButton.button.button-fill')
  );
  sheet.insertRule(
    applyCustomBackgroundAndColorRule('.desktop-card > .card-header')
  );
  sheet.insertRule(
    applyCustomBackgroundAndColorRule('.start-content > .companyInfo')
  );
  sheet.insertRule(applyCustomBackgroundAndColorRule('.navbar'));
  sheet.insertRule(applyCustomBackgroundAndColorRule('.viewer-top'));

  embedBackground &&
    sheet.insertRule(createCustomBgColorRule('.pages-side', embedBackground));
  customTextColor && sheet.insertRule(createCustomColorRule('.navbar .link'));
  customTextColor &&
    sheet.insertRule(createCustomColorRule('.navbar .link > i'));
  customTextColor &&
    sheet.insertRule(
      createCustomColorRule('.desktop-card > .card-header .link > i')
    );

  document.body.classList.add('customBranding');
  if (branding.embedMode) {
    document.body.classList.add('embedMode');
  }
}
